import React, { useState, useEffect } from "react";
import { Layout, Menu, Row, Col, notification } from "antd";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import MobileMenu from "@layouts/mobileMenu";
import {
  adminHorizontalMenuItems,
  adminVerticalMenuItems,
} from "@staticData/admin/adminMenuItems";
import {
  userVerticalMenuItems,
  userHorizontalMenuItems,
} from "@staticData/user/userMenuItems";
import { Spin } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import logo from "@assets/imgs/logo-optimized.png";
import collapsedLogo from "@assets/imgs/collapsed-logo.png";
import { useOnlineStatus } from "@hooks/useOnlineStatus";
import moment from "moment-jalaali";

const INITIALDATA = gql`
  query {
    getProfile {
      name
      profileImg
      userRole
    }
  }
`;
const USERUNREADNOTIFSCOUNT = gql`
  query {
    getUnreadAdminMessagesCount
  }
`;
const { Sider, Content, Header, Footer } = Layout;
const Index = ({ allowedRole }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [userAside, setUserAside] = useState(true);
  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [error, setError] = useState(false);
  const [role, setRole] = useState("");
  const [profileImg, setProfileImg] = useState("");
  const [name, setName] = useState("");
  const [messagesCount, setMessagesCount] = useState(0);

  const location = useLocation();
  const { pathname } = location;
  const isOnline = useOnlineStatus();

  const [getInitialData, initialData] = useLazyQuery(INITIALDATA, {
    onError(error) {
      setError(error);
      console.log("خطا:", error.message);
    },
    onCompleted(data) {
      setError(false);
      setRole(data.getProfile.userRole);
      setProfileImg(data.getProfile.profileImg);
      setName(data.getProfile.name ? data.getProfile.name?.split(" ")[0] : "");
    },
  });

  useEffect(() => {
    if (!isOnline) {
      notification.open({
        message: "اتصال شما به اینترنت قطع شد",
        description: "برای استفاده از امکانات برنامه لازم است که آنلاین شوید.",
        icon: (
          <CloseCircleOutlined
            style={{
              color: "red",
            }}
          />
        ),
      });
    }

    getInitialData();
    function handleWindowResize() {
      setWindowSize(getWindowSize());
      const winWith = getWindowSize().innerWidth;
      if (winWith >= 992) {
        setUserAside(true);
        setCollapsed(false);
      }
      if (winWith < 992 && winWith >= 550) {
        setUserAside(true);
        setCollapsed(true);
      }
      if (winWith < 550) {
        setUserAside(false);
        setCollapsed(true);
      }
    }
    if (windowSize.innerWidth >= 992) setCollapsed(false);
    else setCollapsed(true);
    if (windowSize.innerWidth <= 550) setUserAside(false);
    else setUserAside(true);
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [isOnline]);

  const [getNotifsCount, notifsCount] = useLazyQuery(USERUNREADNOTIFSCOUNT, {
    fetchPolicy: "network-only",
    onCompleted({ getUnreadAdminMessagesCount }) {
      setMessagesCount(getUnreadAdminMessagesCount);
    },
  });

  useEffect(() => {
    if (role === 'USER') getNotifsCount()
  }, [role])

  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken || error.message === "Unauthorized") {
    return <Navigate to="/login" />;
  }
  if (error && error.message !== "Unauthorized") {
    console.log(error);
    return <Navigate to="/error" />;
  }

  if (accessToken && !role && !error) {
    return (
      <Spin size="large" tip="در حال بارگذاری ...">
        <div style={{ height: "100vh", width: "100%" }}></div>
      </Spin>
    );
  }

  if (accessToken && role && !error) {
    const currentActiveMenuKey = pathname?.split("/")[1];
    return (
      <>
        <Layout className="main-layout">
          {(role === "USER" && userAside) || role === "ADMIN" ? (
            <Sider
              className={role === "USER" && "user-site-sider"}
              trigger={React.createElement(
                collapsed ? MenuFoldOutlined : MenuUnfoldOutlined,
                {
                  id: "menu-trigger",
                  onClick: () => setCollapsed(!collapsed),
                }
              )}
              collapsible
              collapsed={collapsed}
            >
              <div className="logo">
                <img
                  src={!collapsed ? logo : collapsedLogo}
                  alt="صفاتک"
                  style={!collapsed ? { width: "150px" } : { width: "40px" }}
                />
              </div>

              <Menu
                theme="dark"
                mode="vertical"
                selectedKeys={currentActiveMenuKey}
                items={
                  role === "USER"
                    ? userVerticalMenuItems(messagesCount)
                    : role === "ADMIN"
                      ? adminVerticalMenuItems
                      : []
                }
              />
            </Sider>
          ) : null}
          <Layout className="site-layout">
            <Header
              className="site-layout-background"
              style={{
                padding: 0,
                background: "transparent",
              }}
            >
              <Menu
                style={{ direction: "ltr" }}
                theme="dark"
                mode="horizontal"
                selectedKeys={null}
                items={
                  role === "USER"
                    ? userHorizontalMenuItems(profileImg, name, messagesCount)
                    : role === "ADMIN"
                      ? adminHorizontalMenuItems(profileImg, name)
                      : []
                }
              />

            </Header>

            <Content
              className="site-layout-background"
              style={{
                margin: "15px 16px",
                padding: 24,
                minHeight: "90vh",
              }}
            >
              {role === allowedRole ? (
                <Outlet context={{ refreshNotifs: getNotifsCount }} />
              ) : (
                <Navigate
                  to="/not-allowed"
                  state={{ from: location }}
                  replace
                />
              )}
            </Content>
            <Footer
              style={{
                textAlign: "center",
                direction: "ltr",
              }}
            >
              <Row>
                <h3 style={{ fontWeight: 500, color: "white" }}>پیوندها: </h3>
              </Row>
              <Row style={{ marginBottom: 5 }}>
                <a href="https://safatec.ir/" target="_blank" rel="noopener noreferrer">سایت صفاتک</a>
              </Row>
              <Row>
                <a href="https://safatec.ir/%d8%aa%d9%85%d8%a7%d8%b3-%d8%a8%d8%a7-%d9%85%d8%a7/" target="_blank" rel="noopener noreferrer">ارتباط با ما</a>
              </Row>
              <Row style={{ marginBottom: 5 }}>
                <a href="https://link.safatec.ir" target="_blank" rel="noopener noreferrer">شبکه ارتباطی اعضای صفاتک</a>
              </Row>
              <Row gutter={30}>
                <Col xs={8}>
                  <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=411911&Code=JxLrHPgZTlhUtUm5Op95uGtINANRtnHJ"
                  >
                    <img
                      referrerPolicy="origin"
                      src="https://trustseal.enamad.ir/logo.aspx?id=411911&Code=JxLrHPgZTlhUtUm5Op95uGtINANRtnHJ"
                      alt=""
                      style={{ cursor: "pointer" }}
                      code="JxLrHPgZTlhUtUm5Op95uGtINANRtnHJ"
                    />
                  </a>
                </Col>
              </Row>
              <Row>
                <div
                  style={{
                    textAlign: "center",
                    direction: "ltr",
                    margin: "auto",
                  }}
                >
                  SafaTec ©{moment(Date.now()).year()}
                </div>
              </Row>
            </Footer>
          </Layout>
          {role === "USER" && <MobileMenu items={userVerticalMenuItems(messagesCount)} />}
        </Layout>
      </>
    );
  }

};

export default Index;

function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}
